import { createFileRoute } from "@tanstack/react-router";

import { PraxaCustomizeSurface } from "../components/praxa/PraxaCustomizeSurface";
import { parsePraxaCustomizeSearch, type PraxaCustomizeTab } from "../praxaCustomize";

export const Route = createFileRoute("/w/$workspaceId/customize")({
  component: PraxaCustomizeRoute,
  validateSearch: parsePraxaCustomizeSearch,
});

function PraxaCustomizeRoute() {
  const { workspaceId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  const updateSearch = (next: { readonly tab?: PraxaCustomizeTab; readonly q?: string }) => {
    const updated = parsePraxaCustomizeSearch({
      tab: next.tab ?? search.tab,
      q: "q" in next ? next.q : search.q,
    });
    void navigate({
      replace: true,
      search: updated,
    });
  };

  return (
    <PraxaCustomizeSurface
      onQueryChange={(query) => updateSearch({ q: query })}
      onTabChange={(tab) => updateSearch({ tab })}
      onWorkspaceChange={(nextWorkspaceId) =>
        void navigate({
          params: { workspaceId: nextWorkspaceId },
          search,
          to: "/w/$workspaceId/customize",
        })
      }
      query={search.q ?? ""}
      tab={search.tab}
      workspaceId={workspaceId}
    />
  );
}
